// Note this is the side menu not the settings button in the menu
settingsMenuButtonClose = { };

settingsMenuButtonClose.create = function() {
    var button = new PIXI.Container();
    
    InputHelpers.addGenerics(button);
    InputHelpers.addAutoplayFlag(button);
    InputHelpers.addCanSpinFlag(button);

    button.canEnable = function() {
    	  return (this._flags.platformEnabled && this._flags.canSpin && !this._flags.autoplayStarted && this._flags.modal.active);
    };	
	
    button.canShow = function() {
    	  return settingsMenu.container.visible; // this._flags.platformVisible && this._flags.canSpin && !gameController.inFreeSpins;
    };
    
    button.onPressedCallback = function() {
        soundManager.play("buttonPressed");
        settingsMenu.hidePopup();
    };

    button._flags.platformEnabled = false;
	  button._flags.platformVisible = false;

    button.onConfig = function(config) {
        button._flags.platformEnabled = true;//config.data.uiElements.btnSettings.enabled;
		    button._flags.platformVisible = true;//config.data.uiElements.btnSettings.visible;
    };

    messageBus.subscribe("spinner:GameConfigEvent", button.onConfig);


    return button;
};

settingsMenuButtonClose.initialise = function(json, object) { };
settingsMenuButtonClose.getFilesRequired = function() { return []; };

resourceManager.registerObjectType("settingsMenuButtonClose", settingsMenuButtonClose.create, settingsMenuButtonClose.initialise, settingsMenuButtonClose.getFilesRequired);
